var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGanttActionGrab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50008 11.8337H8.16675V5.16699H6.50008V11.8337ZM9.00008 0.166992C4.40008 0.166992 0.666748 3.90033 0.666748 8.50033C0.666748 13.1003 4.40008 16.8337 9.00008 16.8337C13.6001 16.8337 17.3334 13.1003 17.3334 8.50033C17.3334 3.90033 13.6001 0.166992 9.00008 0.166992ZM9.00008 15.167C5.32508 15.167 2.33341 12.1753 2.33341 8.50033C2.33341 4.82533 5.32508 1.83366 9.00008 1.83366C12.6751 1.83366 15.6667 4.82533 15.6667 8.50033C15.6667 12.1753 12.6751 15.167 9.00008 15.167ZM9.83342 11.8337H11.5001V5.16699H9.83342V11.8337Z",
    fill: "#637381"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGanttActionGrab);
export default __webpack_public_path__ + "static/media/gantt-action-grab.9ff69215.svg";
export { ForwardRef as ReactComponent };